import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = anon, obj = authed

    useEffect(() => {
        // CRITICAL: If returning from OAuth callback, skip the /me check.
        // AuthCallback will exchange the session_id and establish the session first.
        if (window.location.hash?.includes("session_id=")) {
            return;
        }
        api.get("/auth/me")
            .then((res) => setUser(res.data))
            .catch(() => setUser(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser({ id: data.id, email: data.email, name: data.name, username: data.username, role: data.role });
        return data;
    };

    const register = async ({ email, name, username, password }) => {
        const { data } = await api.post("/auth/register", { email, name, username, password });
        setUser({ id: data.id, email: data.email, name: data.name, username: data.username, role: data.role });
        return data;
    };

    const loginWithGoogle = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    const processGoogleSession = async (sessionId) => {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser({ id: data.id, email: data.email, name: data.name, username: data.username, role: data.role, picture: data.picture });
        return data;
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch (_) {}
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, setUser, login, register, loginWithGoogle, processGoogleSession, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
